import { PORT_FROM, PORT_TO } from 'app/commons/constants/image.const'
import { IPort } from 'app/interface/IBooking'

import React from 'react'
import { useTranslation } from 'react-i18next'

import './styles.scss'

const InfoWindow = ({
  port,
  isP2D,
  isFrom,
}: {
  port: IPort
  index: number
  lat: number
  lng: number
  isP2D: boolean
  isFrom?: boolean
}) => {
  const IconPortRender = isFrom ? PORT_FROM : PORT_TO
  const { t } = useTranslation()
  return (
    <>
      {isFrom && isP2D ? (
        <></>
      ) : (
        <div
          className={isFrom && isP2D ? 'point-p2d' : 'point-port'}
          style={{ backgroundImage: `url(${IconPortRender})` }}
        ></div>
      )}
      <div className="content-info">
        <div className="title">
          <a href={port.infoLink} className="port-name" target="_blank" rel="noopener noreferrer">
            {port.portName}
          </a>
          {port?.imgPort ? (
            <div className="d-flex align-items-center">
              <img width={16} src={port?.imgPort} alt="" />
              <div className="ml5 sub-title">
                {isFrom ? t('liveTracking.loadingPort') : t('liveTracking.destinationPort')}
              </div>
            </div>
          ) : (
            <div className="sub-title">
              {isFrom ? t('liveTracking.loadingPort') : t('liveTracking.destinationPort')}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default InfoWindow
